
(function(){
/* apparition / disparition au scroll, dans les deux sens */
var els=[].slice.call(document.querySelectorAll('.rv'));
var cards=document.querySelector('.cf-cards'), slots=[].slice.call(document.querySelectorAll('.cf-slot'));
var items=els.map(function(e){return {t:e,list:[e]};});
if(cards&&slots.length) items.push({t:cards,list:slots});
var tick=false;
function upd(){tick=false;var vh=innerHeight;
  items.forEach(function(it){var r=it.t.getBoundingClientRect();
    var vis=r.top<vh*.9&&r.bottom>vh*.1, above=r.bottom<=vh*.1;
    it.list.forEach(function(e){
      if(vis){e.classList.remove('up');e.classList.add('in');}
      else{e.classList.remove('in');e.classList.toggle('up',above);}
    });
  });}
function req(){if(!tick){tick=true;requestAnimationFrame(upd);}}
addEventListener('scroll',req,{passive:true});addEventListener('resize',req,{passive:true});
upd();setTimeout(upd,300);
document.querySelectorAll('a[href="#top-offre"]').forEach(function(a){a.addEventListener('click',function(ev){ev.preventDefault();document.getElementById('top-offre').scrollIntoView({behavior:'smooth',block:'start'});});});
})();
